import React, { useState } from "react";
import emailjs from "emailjs-com";
import BannerImage from "../assets/about1.png";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFeedback("");

    emailjs
      .send(
        "service_ojns6pm", // Replace with your EmailJS service ID
        "template_d2olxca", // Replace with your EmailJS template ID
        formData,
        "YVeFaDQAqJTHMPwwT" // Replace with your EmailJS public API key
      )
      .then(
        (response) => {
          setFeedback("Your message has been sent successfully!");
          setFormData({ name: "", email: "", message: "" });
          setIsSubmitting(false);
        },
        (error) => {
          setFeedback("Something went wrong. Please try again.");
          setIsSubmitting(false);
        }
      );
  };

  return (
    <div className="container mx-auto p-6 bg-gray-100">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Contact Tirumala Cocopeat | Coir Pith Inquiries</title>
        <meta
          name="description"
          content="Get in touch with Tirumala Cocopeat for inquiries, product details, and support. Located in Anantapur, Andhra Pradesh, we specialize in coir pith and cocopeat manufacturing."
        />
        <meta
          name="keywords"
          content="Tirumala Cocopeat, coir pith, cocopeat, contact Tirumala Cocopeat, coir products, agricultural solutions, Anantapur"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Tirumala Cocopeat" />
      </Helmet>

      {/* Banner Section */}
      <div
        className="relative bg-cover bg-center h-72 md:h-96 flex items-center justify-center"
        style={{
          backgroundImage: `url(${BannerImage})`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        <h1 className="relative text-white text-4xl md:text-5xl font-bold text-center">
          Contact Us
        </h1>
      </div>

      {/* Contact Content */}
      <div className="mt-8 bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-3xl font-bold text-green-700 text-center mb-6">
          If You Have Any Query, Don’t Hesitate to Contact Us!
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div className="bg-gray-50 p-6 rounded-lg shadow-lg">
            <h3 className="text-lg font-bold text-gray-700 mb-4">Address</h3>
            <p className="text-gray-600 mb-4">
              Tirumala Coco Peat, Mudigallu circle, Anantapur-Bypass road,
              Kalyanadurgam-515761, Anantapur (dist), Andhra Pradesh, India
            </p>
            <h3 className="text-lg font-bold text-gray-700 mb-4">Phone</h3>
            <p className="text-gray-600 mb-4">+91 9492228585</p>
            <h3 className="text-lg font-bold text-gray-700 mb-4">Email</h3>
            <p className="text-gray-600">mramana918@gmail.com</p>
          </div>

          {/* Contact Form */}
          <div className="md:col-span-2 bg-gray-50 p-6 rounded-lg shadow-lg">
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label
                  htmlFor="name"
                  className="block text-gray-700 font-bold mb-2"
                >
                  Full Name
                </label>
                <div className="relative">
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 pl-10 focus:outline-none focus:ring-2 focus:ring-green-500"
                    placeholder="Enter your name"
                    required
                  />
                  <i className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 fa fa-user"></i>
                </div>
              </div>
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="block text-gray-700 font-bold mb-2"
                >
                  Email
                </label>
                <div className="relative">
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md p-2 pl-10 focus:outline-none focus:ring-2 focus:ring-green-500"
                    placeholder="Enter your email"
                    required
                  />
                  <i className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 fa fa-envelope"></i>
                </div>
              </div>
              <div className="mb-4">
                <label
                  htmlFor="message"
                  className="block text-gray-700 font-bold mb-2"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="Write your message here"
                  required
                ></textarea>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className={`bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 transition-colors duration-300 ${
                    isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>
              </div>
              {feedback && (
                <p className="text-center text-green-700 mt-4">{feedback}</p>
              )}
            </form>
          </div>
        </div>
        <div className="rounded-lg shadow-lg overflow-hidden mt-8">
          <iframe
            title="Google Maps Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15447.202598141179!2d77.1146924304809!3d14.553389644189929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb0d71fcb344f1f%3A0x445f441a99ce986f!2sKalyandurg%20mudigallu%20circle!5e0!3m2!1sen!2sin!4v1734263403394!5m2!1sen!2sin"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
// import React, { useState } from "react";
// import BannerImage from "../assets/image2.webp";
// import { Helmet } from "react-helmet";

// const ContactUs = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [feedback, setFeedback] = useState("");

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     setFeedback("");
  
//     try {
//       // Replace with your production URL
//       const response = await fetch("https://cocopeat-backend.vercel.app/contactmail", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });
  
//       const result = await response.json();
  
//       if (response.ok) {
//         setFeedback("Your message has been sent successfully!");
//         setFormData({ name: "", email: "", message: "" });
//       } else {
//         setFeedback(result.message || "Something went wrong. Please try again.");
//       }
//     } catch (error) {
//       setFeedback("Error sending message. Please check your network.");
//     }
  
//     setIsSubmitting(false);
//   };
  

//   return (
//     <div className="container mx-auto p-6 bg-gray-100 pt-16">
//             <Helmet>
//         <title>Contact Tirumala Cocopeat | Coir Pith Inquiries</title>
//         <meta
//           name="description"
//           content="Get in touch with Tirumala Cocopeat for inquiries, product details, and support. Located in Anantapur, Andhra Pradesh, we specialize in coir pith and cocopeat manufacturing."
//         />
//         <meta
//           name="keywords"
//           content="Tirumala Cocopeat, coir pith, cocopeat, contact Tirumala Cocopeat, coir products, agricultural solutions, Anantapur"
//         />
//         <meta name="robots" content="index, follow" />
//         <meta name="author" content="Tirumala Cocopeat" />
//       </Helmet>

//       <div
//         className="relative bg-cover bg-center h-72 md:h-96 flex items-center justify-center"
//         style={{
//           backgroundImage: `url(${BannerImage})`,
//         }}
//       >
//         <div className="absolute inset-0 bg-black bg-opacity-40"></div>
//         <h1 className="relative text-white text-4xl md:text-5xl font-bold text-center">
//           Contact Us
//         </h1>
//       </div>

//       <div className="mt-8 bg-white p-8 rounded-lg shadow-md">
//         <h2 className="text-3xl font-bold text-green-700 text-center mb-6">
//           If You Have Any Query, Don’t Hesitate to Contact Us!
//         </h2>

//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//           <div className="bg-gray-50 p-6 rounded-lg shadow-lg">
//             <h3 className="text-lg font-bold text-gray-700 mb-4">Address</h3>
//             <p className="text-gray-600 mb-4">
//               Tirumala CoCo Peat, Mudigallu circle, Anantapur-Bypass road,
//               Kalyanadurgam-515761, Anantapur (dist), Andhra Pradesh, India
//             </p>
//             <h3 className="text-lg font-bold text-gray-700 mb-4">Phone</h3>
//             <p className="text-gray-600 mb-4">+91 9492228585</p>
//             <h3 className="text-lg font-bold text-gray-700 mb-4">Email</h3>
//             <p className="text-gray-600">mramana918@gmail.com</p>
//           </div>

//           <div className="md:col-span-2 bg-gray-50 p-6 rounded-lg shadow-lg">
//             <form onSubmit={handleSubmit}>
//               <div className="mb-4">
//                 <label htmlFor="name" className="block text-gray-700 font-bold mb-2">
//                   Full Name
//                 </label>
//                 <input
//                   type="text"
//                   id="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-md p-2"
//                   placeholder="Enter your name"
//                   required
//                 />
//               </div>
//               <div className="mb-4">
//                 <label htmlFor="email" className="block text-gray-700 font-bold mb-2">
//                   Email
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-md p-2"
//                   placeholder="Enter your email"
//                   required
//                 />
//               </div>
//               <div className="mb-4">
//                 <label htmlFor="message" className="block text-gray-700 font-bold mb-2">
//                   Message
//                 </label>
//                 <textarea
//                   id="message"
//                   rows="5"
//                   value={formData.message}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-md p-2"
//                   placeholder="Write your message here"
//                   required
//                 ></textarea>
//               </div>
//               <button
//                 type="submit"
//                 className={`bg-green-600 text-white px-6 py-2 rounded-md ${
//                   isSubmitting ? "opacity-50 cursor-not-allowed" : ""
//                 }`}
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? "Sending..." : "Send Message"}
//               </button>
//               {feedback && <p className="mt-4 text-center text-green-700">{feedback}</p>}
//             </form>
//           </div>
//         </div>
//         <div className="rounded-lg shadow-lg overflow-hidden mt-8">
//           <iframe
//             title="Google Maps Location"
//            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15447.202598141179!2d77.1146924304809!3d14.553389644189929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb0d71fcb344f1f%3A0x445f441a99ce986f!2sKalyandurg%20mudigallu%20circle!5e0!3m2!1sen!2sin!4v1734263403394!5m2!1sen!2sin"
//             width="100%"
//             height="350"
//             style={{ border: 0 }}
//             allowFullScreen=""
//             loading="lazy"
//           ></iframe>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;